<template>
  <intersect @enter="animate = true">
    <div
      class="memberTabsContainer container fadeUp"
      :class="animate ? 'animate' : ''"
    >
      <div class="memberTabsInner">
        <swiper
          class="memberTabs"
          ref="memberTabs"
          :options="swiperTabsOptions"
        >
          <swiper-slide v-for="item in menuItems" :key="item.id">
            <router-link
              :to="item.full_url"
              class="memberTab noto-semibold"
              :key="item.id"
              @click.native="dropCloser()"
            >
              {{ item.title }}
            </router-link>
          </swiper-slide>
        </swiper>
      </div>
    </div>
  </intersect>
</template>
<script>
import Intersect from "vue-intersect";
import mainMixin from "@/mixins/main";

export default {
  name: "InvestorsTabs",
  mixins: [mainMixin],
  components: { Intersect },
  data() {
    return {
      swiperTabsOptions: {
        slidesPerView: "auto",
        freeMode: true
      },
      animateMember: true,
      animate: false
    };
  },
  computed: {
    menuItems() {
      if (!this.$store.getters.menuStatus("level3")) return {};
      return this.getMenuFlat("investors", this.$store.getters.menuStatus("level3"))
    }
  },
};
</script>
